import PropTypes from 'prop-types';

/**
 * MVPD provider type.
 */
export default {
  displayName: PropTypes.string,
  ID: PropTypes.string.isRequired,
  logoURL: PropTypes.string,
  setLocalSelectedProvider: PropTypes.func,
  disableAdobeCallback: PropTypes.bool,
};
